import { doClientRequest } from 'services/ErplyAPI/core/ErplyAPI';

import { CFRSalesDocument } from '../types';

const getFranchiseSalesDocuments = async queryProps =>
  doClientRequest<CFRSalesDocument>({
    ...queryProps,
    request: 'getFranchiseSalesDocuments',
  });

export default getFranchiseSalesDocuments;
